module.exports = __webpack_public_path__ + "static/media/driver4.ed04caba.png";